module.exports = __webpack_public_path__ + "static/media/img2.9f9da9a9.jpg";